//=include ./menu.js
//=include ./slick.js

(function($) {

	$(document).ready(function() {

		// Stats

		function countUp(el) {

			var valueEl = $(el).find('.stat-value');
			var value = valueEl.data('value').toString().replace(/,/g, '');
			var innerEl = $(el).find('span');

			var commas = valueEl.data('commas');

			if (commas) {

				$({
					countNum: 0
				}).animate({
					countNum: value
				}, {
					duration: 1000,
					easing: 'linear',
					step: function() {
						innerEl.text(Math.ceil(this.countNum).toLocaleString());
					},
					complete: function() {
						innerEl.text(Math.ceil(value).toLocaleString());
					}
				});

			} else {

				$({
				countNum: 0
				}).animate({
					countNum: value
				}, {
					duration: 1000,
					easing: 'linear',
					step: function() {
						innerEl.text(Math.ceil(this.countNum));
					},
					complete: function() {
						innerEl.text(Math.ceil(value));
					}
				});

			}

		}

		$('.section-stats .item').each(function(n) {

			var self = this;
			console.log(n);

			setTimeout(function() {
				$(self).addClass('active');
				countUp(self);
			}, n*200 )


		});

		// Carousels

		if ($('#banner .item').length > 1) {

			$('#banner .carousel-inner').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				dotsClass: 'carousel-indicators',
				fade: true,
				pauseOnHover: true,
				swipe: false,
				adaptiveHeight: true,
				autoplay: true,
				autoplaySpeed: 5000,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							fade: false,
							swipe: true
						}
					}
				]
			});

		}

		$('.gallery-carousel').slick({
			slidesToShow: 1,
			dots: true,
			dotsClass: 'carousel-indicators',
			fade: true,
			pauseOnHover: true,
			swipe: true,
			adaptiveHeight: false,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 6000,
			//infinite: false,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						fade: false//,
						//swipe: true
					}
				}
			]
		});

		$('.section-clients .items').slick({
			slidesToShow: 7,
			slidesToScroll: 1,
			dots: false,
			dotsClass: 'carousel-indicators',
			fade: false,
			pauseOnHover: true,
			swipe: true,
			adaptiveHeight: true,
			autoplay: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 5,
						swipe: true
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						swipe: true
					}
				},
				{
					breakpoint: 568,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});

		$('.footer-logos .items').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			dots: false,
			dotsClass: 'carousel-indicators',
			fade: false,
			pauseOnHover: true,
			swipe: true,
			adaptiveHeight: true,
			autoplay: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						swipe: true
					}
				},
				{
					breakpoint: 568,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});

		$('.section-stats .items').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			dots: false,
			dotsClass: 'carousel-indicators',
			fade: false,
			pauseOnHover: true,
			swipe: true,
			adaptiveHeight: false,
			autoplay: false,
			infinite: false,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 568,
					settings: {
						slidesToShow: 2,
						dots: true
					}
				}
			]
		});

		$('.post-grid-slider .row').slick({
			slidesToShow: 1,
			swipe: true,
			infinite: false,
			dots: true,
			autoplay: false,
			adaptiveHeight: false,
			dots: false,
			arrows: false,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 568,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 992,
					settings: "unslick"
				}
			]
		});


		// Simple infield labels
		// input needs to have class .form-control
		// label needs to have class .infield
		// input and label need to be wrapped in class .form-group

		// function activateLabel(el) { // Check if input has a value and if it does, give its label class .active
		// 	var $this = $(el);
		// 	var label = $this.closest('.form-group').find('label.infield');
		//
		// 	if($this.val()) {
		// 		label.addClass('active');
		// 	} else {
		// 		label.removeClass('active');
		// 	}
		// }
		//
		// $('.form-control').focus(function() {
		// 	var label = $(this).closest('.form-group').find('label.infield');
		// 	label.addClass('active'); // label should always be active on focus
		// }).blur(function() {
		// 	activateLabel(this); // When we lose focus, we need to check if input has a value
		// }).each(function() {
		// 	activateLabel(this); // And we also check once on load, in case we load the page with fields filled in
		// });
		//
		// $('.wpcf7').on('wpcf7submit', function( event ) {
		// 	$(this).find('label.infield').removeClass('active');
		// });

		// Do things on scroll

		var scrollAmount = 0;
		var oldScrollAmount = 0;
		var scrolledUp = false;
		var $body = $('body');
		var $backToTop = $('#backtotop');

		function draw() {

			oldScrollAmount = scrollAmount;
			scrollAmount = $(window).scrollTop();

			if (scrollAmount < oldScrollAmount) {
				scrolledUp = true;
			} else if (scrollAmount > oldScrollAmount) {
				scrolledUp = false;
			}

			if (scrollAmount > 120) { // Sticky header
				$body.addClass('header-fixed');
			} else {
				$body.removeClass('header-fixed');
			}

			if (scrolledUp) { // Header only visible when you scroll up on mobile
				$body.addClass('header-visible');
			} else {
				$body.removeClass('header-visible');
			}

			if (scrollAmount > 1000) { // Show back to top button
				$backToTop.addClass('active');
			} else {
				$backToTop.removeClass('active');
			}

			requestAnimationFrame(draw);
		}
		requestAnimationFrame(draw);

		// Simple accordion

		$('.accordion-title').on('click', function() {

			var $self = $(this);
			var $accordion = $self.closest('.accordion');
			toggleAccordion( $self, $accordion )
		});

		function toggleAccordion( title, accordion ) {
			if (title.hasClass('active')) {
				title.next('.accordion-content').slideUp();
				title.removeClass('active');
			} else {
				accordion.find('.accordion-content').slideUp();
				accordion.find('.accordion-title').removeClass('active');

				title.next('.accordion-content').slideDown();
				title.addClass('active');
			}
		}

		// Intra page type CTAs.
		$('.cta a[href^="#"]').on('click', function(event) {

			var href = $(this).attr('href');
			if (href.charAt(0) == '#') {
				var accordion = $(href);

				if ( accordion ) {
					event.preventDefault();

					// Open the item.
					toggleAccordion( accordion.find('.accordion-title'), accordion.closest('.accordion') );
				}
			}
		});

		// Anchor links scroll instead of jumping

		//$('a').click(function(event) {
		$(document).on('click', 'a', function(event) {

			var target = $(this).attr('target');
			var href = $(this).attr('href');

			if (href && target != '_blank') {

				if (href.charAt(0) == '#') {
					event.preventDefault();

					if (href != '#') {
						var offset = $(href).offset().top - 50;
						$("html, body").animate({ scrollTop: offset }, 400);
					}
				}
			}
		});

		// Simple share button popups

		$('.share-button').click(function(e) {

			e.preventDefault();

			var Config = {
				Width: 500,
				Height: 500
			};

			var self = $(this);
			var type = self.attr('data-share');
			var title = document.title;
			var documenturl = encodeURIComponent(document.location.href);

			switch (type) {
				case 'twitter':
					var url = 'https://twitter.com/intent/tweet?text=' + title + ':%20'  + documenturl;
					popup(url);
					break;
				case 'facebook':
					var url = 'https://www.facebook.com/sharer/sharer.php?u=' + documenturl;
					popup(url);
					break;
				case 'pinterest':
					var url = 'http://pinterest.com/pin/create/button/?url=' + documenturl + '&description=' +  title;
					popup(url);
					break;
				case 'googleplus':
					var url = 'https://plus.google.com/share?url=' + documenturl;
					popup(url);
					break;
				case 'email':
					var url = 'mailto:?subject=' + documenturl;
					window.open(url);
					break;
			}

			function popup(url) {
				// popup position
				var
						px = Math.floor(((screen.availWidth || 1024) - Config.Width) / 2),
						py = Math.floor(((screen.availHeight || 700) - Config.Height) / 2);

				// open popup
				window.open(url, "social",
						"width="+Config.Width+",height="+Config.Height+
						",left="+px+",top="+py+
						",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");
			}
		});

	});

})(jQuery);
